<script>
export default {
  name: 'nav',
  computed: {
    sidebarItems() {
      return [
        {
          _name: 'CSidebarNav',
          _children: [
            {
              _name: 'CSidebarNavItem',
              _class: 'pl-0',
              name: this.$t('general.header.navs.dashboard'),
              to: { name: 'home' },
            },
            {
              _name: 'CSidebarNavDropdown',
              name: this.$t('general.header.navs.audience'),
              items: [
                {
                  name: this.$t('general.header.navs.audience'),
                  to: { name: 'audience' },
                },
                {
                  name: 'Audience Dashboard',
                  to: { name: 'audience-dashboard' },
                },
                {
                  name: 'Create Audience',
                  to: { name: 'import-contacts' },
                },
                {
                  name: 'Segments',
                  to: { name: 'segments-list' },
                },
              ],
            },
            {
              _name: 'CSidebarNavDropdown',
              name: this.$t('general.header.navs.campaign'),
              items: [
                {
                  name: ' Create New',
                  to: { name: 'campaign' },
                },
                {
                  name: 'Campaign List',
                  to: { name: 'campaignList' },
                },
              ],
            },
            {
              _name: 'CSidebarNavDropdown',
              name: this.$t('general.header.navs.templates'),
              items: [
                {
                  name: 'Template email',
                  to: { name: 'template-emails' },
                },
                {
                  name: 'Template SMS',
                  to: { name: 'template-sms' },
                },
              ],
            },
          ],
        },
      ]
    },
  },
}
</script>
